<template>
	<div class="unitExperience-page">
		<br />
			<router-link :to="'/' + 'unit/' + unitExperience.unit_id">
				<div class="close"></div>
			</router-link>
		<div class="unitExperienceInfo">
		<div class="unitExperienceInfoBox">
			<p>
			{{ $tc('unit', 1) }} : <span>{{ unitExperience.unit_name }}</span>
			</p>
			<p>
			{{ $t('experienceName') }} :
			<span>{{ unitExperience.experience_name }}</span>
			</p>
			<p>
			{{ $t('experienceCat') }} : <span>{{ unitExperience.categories }}</span>
			</p>
		</div>
		</div>
		<br />
		<!-- <div class="unitExperienceDetails">
		<span>{{ $t('unitComments') }}: </span>
		<b-form-textarea
			class="inactive"
			type="text"
			v-model="unitExperience.comments"
			maxlength="300"
			:disabled="!isEditing"
			:class="{ active: !isActive, view: !isEditing }"
		></b-form-textarea>
		</div>
		<br /> -->
		<!-- <div class="unitExperienceDetails">
		<span>{{ $t('maxStock') }}:   </span>
		<input
			class="inactive"
			type="number"
			v-model="unitExperience.stock_max"
			:disabled="!isEditing"
			:class="{ active: !isActive, view: !isEditing }"
		/>
		</div>
		<br/> -->
		<br />
		<!-- <div
		class="edit-btn"
		@click="
			isEditing = !isEditing
			isActive = !isActive
		"
		>
		<font-awesome-icon class="icon" icon="edit" />
		</div>
		<br />
		<div class="edit-btn" v-if="isEditing" @click="changeUnitExpereinceDetails">
		<font-awesome-icon class="icon" icon="save" />
		</div> -->
		<!-- <br />
		<hr /> -->
		<div class="trash-btn normalBtn"  @click="openQRCodeModal">
		<div>
			<font-awesome-icon class="icon" icon="qrcode" />
			<span>   {{ $t('getQRcode') }}</span>        
		</div>
		</div>
		<br />
		<div class="trash-btn higherBtn" @click="openInNewTab(unitExperience.url)">
		<!-- <font-awesome-icon class="icon" icon="shopping-basket" /> -->
		<span>{{ $t('visitBookingPlatform') }}</span>
		</div>
		<br />
		<div class="trash-btn deleteBtn" @click="deleteUnitExperience">
		<font-awesome-icon class="icon" icon="trash" /><span>
			{{ $t('removeUnitExperience') }}</span
		>
		</div>

		<b-modal id="QRcode-modal" size="lg" hide-footer>
		<template v-slot:modal-title>
			<div class="exparLogo">
				<span class="left_area">
				<img src="../../src/assets/static/icons/expar_logo_new2.svg" alt="expar_logo" />
				<span class="logo-text">
					expar
				</span>
				</span>
			</div>         
		</template>  
			<br/>
			<br/>
			<div >
			<div id="qrcode" ref="qrcode"></div>     
			<br/>
			<div class="qr-details">
				<p>{{ $tc('unit', 1) }}: <strong>{{unitExperience.unit_name}}</strong> </p>
				<p>{{ $t('experienceName') }}: <strong>{{unitExperience.experience_name}}</strong> </p>
				<p>{{ $t('experienceCat') }}: <strong>{{unitExperience.categories}}</strong> </p>
			</div>
			<div class="trash-btn" @click="downloadQRCodePdf">
				<span>{{ $t('downloadPDF') }}</span>
			</div>
			<br/>
			</div>
		</b-modal>
		<br />
		<!-- <hr /> -->
		<!-- <figure class="about-img3">
		<img
			class="uploadExample"
			:src="unitExperience.img_path"
		/>
		</figure> -->
		<ConfirmDialog :visible="showConfirmation" class="customClass"></ConfirmDialog>
	</div>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog';
import * as QRCode from 'easyqrcodejs'
import { jsPDF } from 'jspdf'

export default {
  components: {
	ConfirmDialog
  },
  data() {
    return {
      url: this.unitExperience.url,
      size: 100,
      unitId: this.$route.params.unitId,
      experienceId: this.$route.params.experienceId,
      isEditing: false,
      isActive: false,
	  showConfirmation: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
    }
  },
  methods: {
    // deleteUnitExperience(event) {
    //   event.preventDefault()
    //   if (confirm('Are you sure?')) {
    //     this.$store
    //       .dispatch('experience/removeUnitExperience', {
    //         unitId: this.unitId,
    //         experienceId: this.experienceId,
    //       })
    //       .then(() => {
    //         this.$router.push({
    //           path: `/unit/${this.unitId}`,
    //         })
    //       })
    //       .catch((e) => console.log(e))
    //   }
    // },
	deleteUnitExperience(event) {
		event.preventDefault()
		this.$confirm.require({
                message: this.$t('confirmUnitExperienceDelete'),
                header: this.$t('areYouSure'),
                icon: 'pi pi-exclamation-triangle',
				acceptLabel: this.$t('yes'),
				rejectLabel: this.$t('no'),
				acceptIcon: 'pi pi-check',
        		rejectIcon: 'pi pi-times',
                accept: () => {
					this.$store
					.dispatch('experience/removeUnitExperience', {
						unitId: this.unitId,
						experienceId: this.experienceId,
					})
					.then(() => {
						this.$router.push({
						path: `/unit/${this.unitId}`,
						})
					})
                },
                reject: () => {
					this.showConfirmation = false;
                }
        });
	},
    changeUnitExpereinceDetails() {
      if (
        confirm(
          'are you sure? This will rewrite excisting unit experience details'
        )
      ) {
        this.$store.dispatch('experience/editUnitExperience', this.unitExperience)
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    },
    async downloadQRCodePdf() {
      const qrcode = document.getElementById('qrcode');
      let qrCanvas = qrcode.firstChild;

      const imgData = qrCanvas.toDataURL('image/png');              
      const doc = new jsPDF('p', 'mm', 'a4');

      doc.addImage(imgData, 'PNG', 20, 30, 60, 60);

      const dataUri = await this.convertTextToImage()
      doc.addImage(dataUri, 'PNG', 20, 100)

      doc.save(`QR-Code:${this.unitId}-${this.experienceId}.pdf`);
    },
    convertTextToImage() {
      return new Promise((resolve, reject) => {
        const textToConvert = `Unit : ${this.unitExperience.unit_name}\nExperience Name : ${this.unitExperience.experience_name}\nExperience category : ${this.unitExperience.categories}`
        console.log(`textToConvert = `, textToConvert)
        this.$store
          .dispatch('unitProduct/convertTextToImage', {
            text: textToConvert
          })
          .then((response) => {
            return resolve(response.dataUri)
          })
          .catch(error => {
            return reject(error)
          })
      })
    },
    getBase64Image(img) {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      const dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    renderQRCode () {
      let options = {
        text: this.url,
        width: 200,
        height: 200,
        logo: '../../../expar_logo_new.svg',
        dotScale: 0.5,
        PO: '#0c2e44',
        PI: '#fb7377'
      }

      new QRCode(this.$refs.qrcode, options)
    },
    async openQRCodeModal() {
      await this.$bvModal.show('QRcode-modal')
      this.renderQRCode()
    },
    openInNewTab(url) {
     	window.open(url, '_blank')
    }
  },
  template: '<qrcode-vue :value="url"></qrcode-vue>',
  props: {
    unitExperience: {
      type: Object,
      default: () => {
        return {}
      },
    },
    product: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
}
</script>

<style scoped>
.productName {
  text-align: left;
  padding-left: 50px;
  font-size: 3em;
  width: 100%;
}
.unitExperienceDetails {
  margin-left: 10px;
  padding: 0 15px;
}

.unitExperienceInfo {
  padding: 0 5px;
  display: flex;
  justify-content: center;
}
.unitExperienceInfoBox {
	width: 500px;
	border-radius: 10px;
	text-align: left;
	font-size: 1.3em;
	background-color: var(--grey-light);
}

.unitExperienceInfo span {
  font-weight: 600;
}

.unitExperienceInfoBox p {
  margin-bottom: 16px;
  padding: 5px 20px;
}

.exparLogo {
  text-align: left;
  margin-bottom: -15px;
}
.left_area img {
	width:20%;
	padding: 5px;
	margin-bottom: 10px;
}
.left_area span {
  font-family: "Nasalization", Helvetica, Arial;  
  color: var(--bg);
  font-size: 2rem;
  letter-spacing: 0px;
  font-weight: 500;
  margin-left: -6px;
}

.trash-btn {
  background-color: var(--bg-light);
  cursor: pointer;
  color: var(--bright);
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 15em;
  text-decoration:none;
}

.higherBtn{
  height: 60px;
}
.normalBtn{
  height: 36px;
}
.deleteBtn{
  height: 36px;
  background-color: var(--primaryDark);
}

.trash-btn:active {
  text-decoration:none;
}

.trash-btn div {
  text-align: left;
  margin-left: 10px;
}

.delete-btn {
  background-color: var(--primaryDark);
  cursor: pointer;
  color: var(--bright);
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 15em;
  height: 32px;
  text-decoration:none;
  margin-bottom: 20px;
}

.delete-btn:active {
	text-decoration:none;
}

.qr-details {
  text-align: left;
}

.uploadDetails {
  font-size: 1.5em;
}

.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  text-align: center;
  vertical-align: top;
}
.uploadExample {
  max-width: 300px;
  width: 100%;
}

textarea {
  padding: 10px;
  width: 500px;
  height: 180px;
}

@media screen and (min-width: 500px) {
  .hideDesktop {
    display: none;
  }
}

@media screen and (max-width: 560px) {
  textarea {
    width: 100%;
    height: 250px;
  }
  .uploadDetails {
    font-size: 1.2em;
  }
    .unitExperienceInfo {
    margin-top: -20px;
  }
  .unitExperienceInfoBox {
    font-size: 1.1em;
	margin-top: 5px;
    padding: 20px 10px;
  }
  .unitExperienceDetails {
    text-align: left;
  }
}

@media screen and (max-width: 415px) {
  textarea {
    height: 100px;
  }
  .productName {
    font-size: 2em;
    font-weight: 600;
    text-align: left;
    padding-left: 0;
  }
  .product-page div {
    text-align: left;
    margin-left: 20px;
  }
  .close {
	right: 20px;
}
}

.edit-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  margin: auto !important;

  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 30px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
.active {
  border-radius: 3.5px;
  background: none !important;
  font-weight: 600;
  font-style: normal !important;
}
.inactive {
  background: rgba(
    185,
    123,
    66,
    0.4
  ); /* when mouse over to the drop zone, change color */
  border-radius: 3.5px;
  font-style: italic;
}

.trash-btn {
  cursor: pointer;
}
.icon {
  font-size: 1.3em;
  padding: 1px;
}
.close {
	position: absolute;
	right: 35px;
	top: 15px;
	width: 25px;
	height: 25px;
	opacity: 0.3;
	padding: 10px;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
</style>
